/* RESPONSIBLE TEAM: team-actions */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import type Transition from '@ember/routing/transition';

type TransitionWithIntent = Transition & { intent: { url: string | null } };

export default class CustomActionsRedirectRoute extends Route {
  @service declare router: RouterService;

  beforeModel(transition: TransitionWithIntent) {
    let url = transition.intent.url;
    if (!url) {
      this.router.replaceWith('apps.app.settings.app-settings.custom-actions');
      return;
    }
    let correctedUrl = url.replace(
      '/settings/app-settings/custom-actions',
      '/settings/app-settings/data-connectors',
    );
    this.router.replaceWith(correctedUrl);
  }
}
